import {EzContent, EzLayout} from '@ezcater/recipe';
import styled from '@emotion/styled';
import {useTranslation} from 'react-i18next';
import {VFC} from 'react';
import {DeliverySetup} from 'services/graphql/types';

const DriverAskForDeliverySetupContainer = styled.div`
  margin-bottom: 1rem;
`;

const DriverAskFor = styled.div`
  margin-right: ${({theme}) => theme.recipeSpacing.md};
`;

const StyledLabel = styled.div`
  font-weight: 700;
`;

interface Props {
  readonly type: 'pickup' | 'dropoff';
  readonly driverAskFor?: string | null;
  readonly instructions?: string | null;
  readonly deliverySetup?: `${DeliverySetup}` | null;
}

const ContactSection: VFC<Props> = ({type, deliverySetup, driverAskFor, instructions}) => {
  const {t} = useTranslation();

  if (!driverAskFor && !instructions && !deliverySetup) {
    return null;
  }

  return (
    <>
      <EzContent>
        {(driverAskFor || deliverySetup) && (
          <DriverAskForDeliverySetupContainer>
            <EzLayout layout="cluster">
              {driverAskFor && (
                <DriverAskFor>
                  <StyledLabel>{t('driverProgress.contactSection.driverAskFor')}</StyledLabel>
                  <div>{driverAskFor}</div>
                </DriverAskFor>
              )}
              {deliverySetup && (
                <div>
                  <StyledLabel>
                    {t('driverProgress.contactSection.deliverySetup.label')}
                  </StyledLabel>
                  {t(`driverProgress.contactSection.deliverySetup.values.${deliverySetup}`)}
                </div>
              )}
            </EzLayout>
          </DriverAskForDeliverySetupContainer>
        )}
        <div>
          <StyledLabel> {t(`driverProgress.contactSection.${type}Instructions`)}</StyledLabel>
          {instructions || t('driverProgress.contactSection.noInstructions')}
        </div>
      </EzContent>
    </>
  );
};

export default ContactSection;
